<template>
  <b-card-body>
    <h5 style="margin-top: 25px;">{{ $t('questionalternative') }}</h5>
    <div v-if="isDefaultLanguage">
      <b-input-group v-for="(alternative, alternativeIndex) in question.alternatives" :key="alternative.id" class="alternatives">
        <b-form-input type="text" v-model="alternative.text" />
        <b-input-group-append is-text>
          <input :id="`alternative-${alternative.text}`" class="me-2" type="checkbox" :checked="alternative.points > 0" :value="1" @change="e => onSelectAlternative(e, alternative)" />
          <label :for="`alternative-${alternative.text}`">
            {{ $t('privatePage.scaleQuestionsCorrectAnswer') }}
          </label>
        </b-input-group-append>
        <b-input-group-append>
          <b-button v-if="isDefaultLanguage"
                variant="danger"
                @click.stop="deleteObjectFromCollection(question.alternatives, alternativeIndex)">
                x
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
    <div v-else>
      <b-input-group v-for="(alternative) in question.alternatives" :key="alternative.id" class="alternatives">
        <b-form-input type="text" v-model="alternative.text" />
        <b-form-input readonly disabled type="text" v-model="alternative.defaultText" />
      </b-input-group>
    </div>

    <b-button ref="addAlternativeButton"
              class="me-2"
              style="margin-top: 5px;"
              v-if="isDefaultLanguage"
              @click.stop="addAlternative(question.alternatives)">
              {{ $t('privatePage.scaleQuestionsAlternativeAdd') }}
    </b-button>

    <b-button ref="deleteQuestionButton"
      variant="danger"
      style="margin-top: 5px;"
      v-if="isDefaultLanguage && isPartOfCollection"
      @click.stop="$emit('onDeleteQuestion', questionIndex)">
      {{ $t('privatePage.scaleQuestionsDelete') }}
    </b-button>
  </b-card-body>
</template>

<script>
import editorFuncs from '../questioneditorfuncs'

export default {
  name: 'ledord-module',
  props: {
    question: {},
    questionIndex: 0,
    isDefaultLanguage: false,
    isPartOfCollection: false
  },
  methods: {
    deleteObjectFromCollection(collection, index) {
      editorFuncs.deleteObjectFromCollection(collection, index)
    },
    addAlternative() {
      editorFuncs.addAlternative(
        this.question.alternatives
      )
    },
    onSelectAlternative(event, selected) {
      const value = event.target.value
      const checked = event.target.checked
      if (checked) {
        selected.points = value
      } else {
        selected.points = 0
      }
    }
  },
  created() {
    if (this.question.alternatives.length === 0) {
      this.addAlternative()
    }
  }
}
</script>

<style scoped>
.alternatives {
  margin-bottom: 5px;
}
</style>
